import moment from 'moment';

const DIRECTION_DEFS = [
  { start: 0, end: 15, desc: 'North' },
  { start: 15, end: 75, desc: 'N. East' },
  { start: 75, end: 105, desc: 'East' },
  { start: 105, end: 165, desc: 'S. East' },
  { start: 165, end: 195, desc: 'South' },
  { start: 195, end: 255, desc: 'S. West' },
  { start: 255, end: 285, desc: 'West' },
  { start: 285, end: 345, desc: 'N. West' },
  { start: 345, end: 360, desc: 'North' },
];

const KM_PER_MILE = 1.609344;


const deviceBattery = (device) => {
  // Preference is to display battery level from the battery field, falling back to whatever is reported
  // in the position. (AT1s most accurate reading is heartbeat)

  if (device.battery !== null && device.battery !== undefined) {
    return device.battery;
  }

  const position = device.position || device.lastPosition;
  if (position) {
    return position.battery || null;
  }

  return null;
}

const getMotionDescription = (device) => {
  if (!device.position) {
    return 'N/A';
  }

  const { heading } = device.position;
  if (typeof heading !== 'number' || (heading < 0 || heading > 360)) {
    return 'N/A';
  }

  const direction = DIRECTION_DEFS.find(def => heading >= def.start && heading < def.end).desc;

  const speedKm = Number.parseFloat(device.position.speed) || 0;
  return `Moving ${direction} at ${(speedKm / KM_PER_MILE).toFixed(0)} mph`;
};

function getGreaterDate(date1, date2) {
  // Check if both dates are null
  if (!date1 && !date2) {
      return null;
  }

  // If one of the dates is null, return the other date
  if (!date1) {
      return date2;
  }

  if (!date2) {
      return date1;
  }

  // If both dates are not null, compare them and return the greater
  const date1Obj = new Date(date1);
  const date2Obj = new Date(date2);

  return date1Obj > date2Obj ? date1 : date2;
}

const lastSeenDescription = (device) => {
  const lastseenAt = device.lastseenAt;
  const lastPositionAt = device.position && device.position.position_at;

  const timestamp = getGreaterDate(lastseenAt, lastPositionAt);

  if (timestamp) {
    return formatTimeFromNow(timestamp);
  }

  return 'N/A';
}

const formatTimeFromNow = (timestamp) => {
  return moment(timestamp).fromNow()
    .replace('hour', 'hr')
    .replace('minute', 'min')
    .replace('second', 'sec');
}

export { deviceBattery, getMotionDescription, lastSeenDescription, formatTimeFromNow };

